/**
 * ./src/landing/Header.js
 * 
 * This component renders the **navigation bar** at the top of the application.
 * It displays the **FlowNow** logo, the user's profile picture, and a personalized greeting.
 * 
 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "./icons/logo.svg";
import userIcon from "./icons/userIcon.svg";

const Header = () => {
  const [username, setUsername] = useState("User");
  const navigate = useNavigate();

  useEffect(() => {
    // Get username from localStorage
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    navigate("/auth");
  };

  return (
    <header className="header">
      <div className="header-logo-container">
        <img src={logo} alt="FlowNow Logo" className="header-logo" />
        <span className="header-title">FlowNow</span>
      </div>
      <div className="name-icon-container">
        <div className="header-user-info">
          <p>Hello, {username}</p>
          
          <div className="header-user-icon-border">
            <img src={userIcon} alt="User Icon" className="header-user-icon" />
          </div>
          <button onClick={handleLogout} className="logout-button">Logout</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
